import { watch, ref, onUnmounted } from 'vue'
import router from '@/router'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import lookups from '@/assets/json/clientLookups.json'
import useCommonFun from '@/composables/useCommonFun'

import { useFormStore } from '@/stores/form'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const dateOfBirthWatch = () => {
  const birthDateWatcher = ref()
  const formStore = useFormStore()
  birthDateWatcher.value = watch(
    () => formStore.form.values.dateOfBirth,
    (newVal) => {
      if (newVal && useCommonFun().ageComparison(newVal, 15, '>=')) {
        let extendObj = {}
        if (formStore.form.values.workTypeId) {
          const isGovernment = formStore.form.values.workTypeId == lookups.workTypes.government
          const isPrivate = formStore.form.values.workTypeId == lookups.workTypes.Private
          //government
          if (isGovernment) {
            extendObj = {
              showCompanyName: false,
              showGovernmentalDepartment: true
            }
          }
          //private
          else if (isPrivate) {
            extendObj = {
              showCompanyName: true,
              showGovernmentalDepartment: false
            }
          }
        }

        formStore.extraMap = {
          ...formStore.extraMap,
          showWorkType: true,
          showEducationLevel: true,
          ...extendObj
        }
      } else {
        formStore.extraMap = {
          ...formStore.extraMap,
          showWorkType: false
        }
      }
    }
  )
  onUnmounted(() => {
    birthDateWatcher.value && birthDateWatcher.value()
  })
}

const changeIdentificaterWatch = () => {
  const identificaterWatch = ref()
  const formStore = useFormStore()
  const clearIdentificater = () => {
    if (!formStore.form.values.identificater) {
      formStore.form.setValues({
        resiVisaDepartmentCode: undefined,
        resiDepartmentCode: undefined,
        resiVisaYear: undefined,
        resiYear: undefined,
        resiVisaServiceCode: undefined,
        resiServiceCode: undefined,
        resiVisaSequenceNumber: undefined,
        resiSequenceNumber: undefined
      })
    }
    formStore.extraMap.finesWarningMessage = undefined
    formStore.extraMap.showFinesWarningMessage = undefined
    formStore.extraMap.showchangeStatusMessage = undefined
  }
  identificaterWatch.value = watch(
    () => formStore.form.values.identificater,
    (newVal) => {
      formStore.extraMap.showUnifiedNumber = newVal == 1
      formStore.extraMap.showFileNumber = newVal == 2
      clearIdentificater()
    }
  )
  onUnmounted(() => {
    identificaterWatch.value && identificaterWatch.value()
  })
}

const secondMobileNumberWatch = () => {
  const secondMobileNumberWatcher = ref()
  const formStore = useFormStore()

  secondMobileNumberWatcher.value = watch(
    () => formStore.form.values.deliveryMobileNumber,
    (newVal) => {
      if (newVal && formStore.form.values?.secondMobileNumber == newVal) {
        formStore.form.setValues({
          secondMobileNumber: ''
        })
      }
    }
  )
  onUnmounted(() => {
    secondMobileNumberWatcher.value && secondMobileNumberWatcher.value()
  })
}

const deliveryMobileNumberWatch = () => {
  const deliveryMobileNumberWatcher = ref()
  const formStore = useFormStore()

  deliveryMobileNumberWatcher.value = watch(
    () => formStore.form.values.secondMobileNumber,
    (newVal) => {
      if (newVal && formStore.form.values?.deliveryMobileNumber == newVal) {
        doNotify('', i18n.global.t('insertDeffMobileNumbers'))
        formStore.form.setValues({
          secondMobileNumber: ''
        })
      }
    }
  )
  onUnmounted(() => {
    deliveryMobileNumberWatcher.value && deliveryMobileNumberWatcher.value()
  })
}
export default function () {
  return {
    changeIdentificaterWatch,
    secondMobileNumberWatch,
    deliveryMobileNumberWatch,
    dateOfBirthWatch
  }
}
